export interface IViewAcceleration {
    viewId: string;
    accelerationState: string;
}

export enum DataAccelerationState {
    Pending = 'Pending',
    Off = 'Off',
    On = 'On'
}